export const GET_DSP_USER_LIST = "get_dsp_user_list";
export const GET_TARIFF = "GET_TARIFF";
export const GET_UNUSED_VOUCHER = "GET_UNUSED_VOUCHER";
export const GET_VOUCHER_MANAGEMENT = "GET_VOUCHER_MANAGEMENT";
export const SAVE_INVOICE = "SAVE_INVOICE";
export const CHECK_VOUCHER_INVOICE = "CHECK_VOUCHER_INVOICE";

//Sim

export const GET_SIM_INVENTORY = "GET_SIM_INVENTORY";
export const GET_SIM_DISTRIBUTION = "GET_SIM_DISTRIBUTION";
export const GET_ADMIN_USER_1 = "GET_ADMIN_USER_1";
export const MANAGE_SIM_INVENTORY = "MANAGE_SIM_INVENTORY";
export const GET_SIM_USER_DISTRIBUTION = "GET_SIM_USER_DISTRIBUTION";
export const GET_USER_SIM_STOCK = "GET_USER_SIM_STOCK";
export const GET_USER_TYPES = "GET_USER_TYPES";
export const SAVE_INVOICE_SIM = "SAVE_INVOICE_SIM";
export const CHECK_SIM_INVOICE = "CHECK_SIM_INVOICE";
export const GET_SELLING_PRICE = "GET_SELLING_PRICE";
export const GET_SIM_ICCID = "GET_SIM_ICCID";
export const MANAGE_BULK_SIM_INVENTORY = "MANAGE_BULK_SIM_INVENTORY";
export const GET_SIM_COUNT = "GET_SIM_COUNT";
export const GET_MULTISELLING_PRICE = "GET_MULTISELLING_PRICE";
export const MANAGE_BULK_MULTI_SIM_INVENTORY = "MANAGE_BULK_MULTI_SIM_INVENTORY";
export const CHECK_MULTI_SIM_INVOICE = "CHECK_MULTI_SIM_INVOICE";

//report
export const GET_VOUCHER_SALE = "GET_VOUCHER_SALE";
export const GET_TOTAL_STOCK = "GET_TOTAL_STOCK";
export const INVOICE_LIST = "INVOICE_LIST";
export const INVOICE_DOWNLOAD = "INVOICE_DOWNLOAD";
export const INVOICE_UPDATE = "INVOICE_UPDATE";
export const CLEAR_DELIVERY_NOTES_PREVIEW = "CLEAR_DELIVERY_NOTES_PREVIEW";
export const CLEAR_INVOICE_PREVIEW = "CLEAR_INVOICE_PREVIEW";
export const DELETE_DELEIVERY_NOTE = "DELETE_DELEIVERY_NOTE";

//Customer Invoice List
export const GET_CUSTOMER_INVOICE_LIST = "GET_CUSTOMER_INVOICE_LIST";
export const GET_INVOICE_LIST = "GET_INVOICE_LIST";
export const UPDATE_DISCOUNT = "UPDATE_DISCOUNT";
export const MANAGE_RETURN_INVOICE = "MANAGE_RETURN_INVOICE";
export const GET_RETURN_INVOICE_LIST = "GET_RETURN_INVOICE_LIST";
export const GET_SIM_SEARCH = "GET_SIM_SEARCH";
export const GET_VOUCHER_SEARCH = "GET_VOUCHER_SEARCH";
export const GENERATE_DELIVERY_NOTES = "GENERATE_DELIVERY_NOTES";
export const GENERATE_INVOICE = "GENERATE_INVOICE";

export const GET_DROPDOWN_USERS = "GET_DROPDOWN_USERS";
export const OFFICE_USER_MENUS = "OFFICE_USER_MENUS";

//Users
export const USER_LIST = "USER_LIST";
export const NEW_USER = "NEW_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const GET_DSPUSER = "GET_DSPUSER";
export const GET_DSP_USERS_LIST = "GET_DSP_USERS_LIST";
export const GET_DSP_USER_1 = "GET_DSP_USER_1";
export const GET_DSP_USER_RETAILER = "GET_DSP_USER_RETAILER";
export const GET_ADMIN_USERS_1 = "GET_ADMIN_USERS_1";
export const GET_INVOICE_MENUS = "GET_INVOICE_MENUS";
